import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

export default class MarketSettingsPropertyTagsIndexRoute extends Route {
  @service declare featureToggle: Services['feature-toggle'];
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    super.beforeModel(transition);

    if (
      !this.featureToggle.hasFeatureToggle(FEATURE_TOGGLES.CUSTOM_PROPERTY_TAGS)
    ) {
      void this.router.replaceWith('market.settings.property-tags.organize');
    }
  }
}
